import {useEffect, useState} from "react";

/**
 * Tracks browser connectivity via navigator.onLine + the window online/offline
 * events. Reflects whether the device has a network link, not whether the
 * QuickCom API itself is reachable (a captive portal or a downed backend can
 * still report `true` here).
 */
const useOnlineStatus = () => {
    const [isOnline, setIsOnline] = useState(() =>
        typeof navigator === "undefined" ? true : navigator.onLine
    );

    useEffect(() => {
        const goOnline = () => setIsOnline(true);
        const goOffline = () => setIsOnline(false);
        window.addEventListener("online", goOnline);
        window.addEventListener("offline", goOffline);
        return () => {
            window.removeEventListener("online", goOnline);
            window.removeEventListener("offline", goOffline);
        };
    }, []);

    return isOnline;
};

export default useOnlineStatus;
